import React from "react";
import { Card, Tabs, Typography } from "antd";
import CashReport from "./reportPage/CashReport";
import CardReport from "./reportPage/CardReport";
import BankReport from "./reportPage/BankReport";
import OnlineReport from "./reportPage/OnlineReport";
import OtherReport from "./reportPage/OtherReport";

const getPermission = (link) => {
  try {
    const raw = localStorage.getItem("ome_permission");
    const parsed = JSON.parse(raw);
    const permissions = Array.isArray(parsed) ? parsed : JSON.parse(parsed);
    return permissions.find(p => p.link === link) || { add: false, edit: false, delete: false, read: false };
  } catch { return { add: false, edit: false, delete: false, read: false }; }
};

const PaymodeViseReport = () => {

  const perm = getPermission('/finance/reports/pay-mode-vise');


  const tabItemsData = [
    {
      key: "1",
      label: "Cash Report",
      content: <CashReport />
    },
    {
      key: "2",
      label: "Card Payment Report",
      content: <CardReport />
    },
    {
      key: "3",
      label: "Bank Transfer Report",
      content: <BankReport />
    },
    {
      key: "4",
      label: "Online Payment Report",
      content: <OnlineReport />
    },
    {
      key: "5",
      label: "Other Payment Report",
      content: <OtherReport />
    }
  ];



  const tabItems = tabItemsData.map(item => ({
    key: item.key,
    label: item.label,
    children: item.content
  }));

if (!perm.read) {
    return (
      <Card title="Pay Mode Vise Report" size="large">
        <Typography.Text type="secondary">You don't have permission to view this page.</Typography.Text>
      </Card>
    );
  }

  return (

    <Card
      title="Pay Mode Vise Report"
      size="large"
    >

      <Tabs
        size="large"
        tabPosition="left"
        items={tabItems}
        destroyInactiveTabPane={false}
      />


    </Card>
  );
};

export default PaymodeViseReport;
